import { resolveMessage } from "./errorMessages"
import { useErrorStore } from "./errorStore"
import type { ActiveError, ErrorCategory, ErrorSeverity } from "./types"

interface RunErrorEventLike {
  type: string
  message?: string
  code?: string
  metadata?: {
    severity?: string
    category?: string
    retryable?: boolean
  }
}

interface ToolWarningEventLike {
  type: string
  name: string
  value: {
    code: string
    severity: string
    category: string
    user_message: string
    retryable: boolean
  }
}

interface HttpErrorBody {
  code: string
  message: string
  severity: string
  category?: string
  retryable: boolean
}

export function routeRunErrorEvent(event: RunErrorEventLike, threadId: string): void {
  const error: ActiveError = {
    code: event.code ?? "UNKNOWN_ERROR",
    severity: (event.metadata?.severity ?? "fatal") as ErrorSeverity,
    category: (event.metadata?.category ?? "unknown") as ErrorCategory,
    userMessage: resolveMessage(event.code ?? "UNKNOWN_ERROR", event.message),
    retryable: event.metadata?.retryable ?? true,
    threadId,
    timestamp: Date.now(),
    source: "stream",
  }
  useErrorStore.getState().addError(error)
}

export function routeToolWarningEvent(event: ToolWarningEventLike, threadId: string): void {
  const v = event.value
  const error: ActiveError = {
    code: v.code,
    severity: v.severity as ErrorSeverity,
    category: v.category as ErrorCategory,
    userMessage: resolveMessage(v.code, v.user_message),
    retryable: v.retryable,
    threadId,
    timestamp: Date.now(),
    source: "tool",
  }
  useErrorStore.getState().addError(error)
}

export function routeHttpError(body: HttpErrorBody, threadId: string): void {
  const error: ActiveError = {
    code: body.code,
    severity: body.severity as ErrorSeverity,
    category: (body.category as ErrorCategory) ?? "unknown",
    userMessage: resolveMessage(body.code, body.message),
    retryable: body.retryable,
    threadId,
    timestamp: Date.now(),
    source: "http",
  }
  useErrorStore.getState().addError(error)
}
